export default __webpack_public_path__ + "files/media/home-ar-l.b1cd816a.jpg";